import { createPortal } from 'react-dom';
import styles from './BulkAddModal.module.scss';
import { crossBtnGrey } from '../../assets/hostedassets';
import Button from '../_custom/Button/Button';
import { useBulkAddModalLogic } from './useBulkAddModalLogic';

// NOTE: preserves the pre-existing hand-rolled modal/backdrop pattern extracted verbatim from GlobalSearch; consolidation onto _custom/Modal deferred to keep this temporary outage guard visually/behaviorally identical.

type BulkAddModalProps = {
    initialText?: string;
    onClose: () => void;
};

/**
 * Shared Bulk Add modal — extracted from GlobalSearch so the manual "Bulk Add" button and any
 * rerouted Add Lead mount points (Karza-outage guard) render/submit identically.
 */
const BulkAddModal = ({ initialText = '', onClose }: BulkAddModalProps) => {
    const { bulkText, setBulkText, bulkLoading, handleBulkConfirm, hasUserEditedRef } = useBulkAddModalLogic(initialText, onClose);

    const setBulkTextareaRef = (el: HTMLTextAreaElement | null) => {
        if (el) {
            el.focus();
        }
    };

    return createPortal(
        <div className={styles.BulkBackdrop}>
            <div className={styles.BulkModal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.BulkHeader}>
                    <h2 className={styles.BulkTitle}>Bulk Add</h2>

                    <span className={styles.BulkClose} onClick={onClose}>
                        <img src={crossBtnGrey} alt="close" className={styles.BulkCloseIcon} />
                    </span>
                </div>
                <div>
                    {bulkText.trim() && <div className={styles.BulkSubtitle}>Add Comma Separated Names, CIN, LLPIN, PAN or GSTIN.</div>}
                    <textarea
                        ref={setBulkTextareaRef}
                        className={`${styles.BulkTextarea} ${bulkText.trim() ? styles.BulkTextareaFilled : ''}`}
                        value={bulkText}
                        placeholder="Add Comma Separated Names, CIN, LLPIN, PAN or GSTIN"
                        onChange={(e) => {
                            hasUserEditedRef.current = true;
                            setBulkText(e.target.value);
                        }}
                    />
                </div>
                <Button
                    text="Confirm"
                    disabled={!bulkText.trim()}
                    loading={bulkLoading}
                    onClick={handleBulkConfirm}
                    variant="purple"
                    size="wide"
                    className={styles.BulkConfirmButton}
                />
            </div>
        </div>,
        document.body,
    );
};

export default BulkAddModal;
